// ==========================================
// Social Proof Manager (Модульна версія)
// ==========================================
export class SocialProofManager {
    constructor(messages, boxId = "social-proof", textId = "proof-text") {
        this.messages = messages || [];
        this.box = document.getElementById(boxId);
        this.text = document.getElementById(textId);
        this.lastIndex = -1;
        this.showDuration = 5000; // показ повідомлення, мс
        this.initialDelay = 120000; // перший показ через 2 хв
        this.intervalDelay = 720000; // наступні кожні 12 хв
        this.intervalId = null;
    }

    init() {
        if (!this.box || !this.text || !this.messages.length) return;
        setTimeout(() => {
            this.showRandomMessage();
            this.intervalId = setInterval(() => this.showRandomMessage(), this.intervalDelay);
        }, this.initialDelay);
    }

    showRandomMessage() {
        if (!this.messages.length) return;

        let index;
        do {
            index = Math.floor(Math.random() * this.messages.length);
        } while (index === this.lastIndex);
        this.lastIndex = index;

        this.text.innerHTML = this.messages[index];
        this.box.classList.remove("hidden");

        setTimeout(() => this.box.classList.add("hidden"), this.showDuration);
    }

    stop() {
        if (this.intervalId) clearInterval(this.intervalId);
    }
}

// ==========================================
// Ініціалізація через функцію
// ==========================================
export function initSocialProof(messages, boxId, textId) {
    const manager = new SocialProofManager(messages, boxId, textId);
    manager.init();
    return manager;
}

// ==========================================
// Повідомлення Social Proof
// ==========================================
export const socialProofMessages = [
    "🤖 Djon<br>- Марія скористалась створенням резюме 📄",
    "🤖 Djon<br>- Олег отримав лендінг 🌐",
    "🤖 Djon<br>- Анна має персональне портфоліо 🎨",
    "🤖 Djon<br>- Ігор перевірив лендінг ✅",
    "🤖 Djon<br>- Катерина протестувала генератор текстів для резюме ✍️",
    "🤖 Djon<br>- Дмитро отримав банер для соцмереж 🖼️",
    "🤖 Djon<br>- Вікторія має готовий шаблон для соцмереж 📱",
    "🤖 Djon<br>- Сергій скористався перевіркою лендінгу ✅",
    "🤖 Djon<br>- Олена переглянула шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Тарас отримав готовий банер для соцмереж 🖌️",
    "🤖 Djon<br>- Наталя протестувала генератор текстів для портфоліо ✍️",
    "🤖 Djon<br>- Вадим перевірив лендінг для мобільної версії 📱",
    "🤖 Djon<br>- Інна має готовий шаблон для соцмереж 🖼️",
    "🤖 Djon<br>- Юрій скористався міні-сервісом генерації текстів ✍️",
    "🤖 Djon<br>- Людмила перевірила свій лендінг ✅",
    "🤖 Djon<br>- Максим отримав банер для реклами у соцмережах 📢",
    "🤖 Djon<br>- Аня переглянула шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Денис скористався перевіркою портфоліо ✅",
    "🤖 Djon<br>- Світлана має готовий шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Роман протестував генератор текстів для резюме ✍️",
    "🤖 Djon<br>- Ірина скористалась створенням резюме 📄",
    "🤖 Djon<br>- Володимир перевірив лендінг ✅",
    "🤖 Djon<br>- Тетяна має персональне портфоліо 🎨",
    "🤖 Djon<br>- Андрій протестував генератор текстів для резюме ✍️",
    "🤖 Djon<br>- Оксана отримала банер для соцмереж 🖼️",
    "🤖 Djon<br>- Євген має готовий шаблон для соцмереж 📱",
    "🤖 Djon<br>- Назар скористався перевіркою лендінгу ✅",
    "🤖 Djon<br>- Марина переглянула шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Ілля отримав готовий банер для соцмереж 🖌️",
    "🤖 Djon<br>- Софія протестувала генератор текстів для портфоліо ✍️",
    "🤖 Djon<br>- Павло перевірив лендінг для мобільної версії 📱",
    "🤖 Djon<br>- Оля має готовий шаблон для соцмереж 🖼️",
    "🤖 Djon<br>- Ярослав скористався міні-сервісом генерації текстів ✍️",
    "🤖 Djon<br>- Віра перевірила свій лендінг ✅",
    "🤖 Djon<br>- Костянтин отримав банер для реклами у соцмережах 📢",
    "🤖 Djon<br>- Ліза переглянула шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Микита скористався перевіркою портфоліо ✅",
    "🤖 Djon<br>- Наталія має готовий шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Олександр протестував генератор текстів для резюме ✍️",
    "🤖 Djon<br>- Світлана скористалась створенням резюме 📄",
    "🤖 Djon<br>- Ігор перевірив лендінг ✅",
    "🤖 Djon<br>- Анастасія має персональне портфоліо 🎨",
    "🤖 Djon<br>- Вадим протестував генератор текстів для резюме ✍️",
    "🤖 Djon<br>- Дарина отримала банер для соцмереж 🖼️",
    "🤖 Djon<br>- Роман має готовий шаблон для соцмереж 📱",
    "🤖 Djon<br>- Тетяна скористалась перевіркою лендінгу ✅",
    "🤖 Djon<br>- Олег переглянув шаблон для соцмереж 🖌️",
    "🤖 Djon<br>- Інна отримала готовий банер для соцмереж 🖌️",
    "🤖 Djon<br>- Сергій протестував генератор текстів для портфоліо ✍️",
    "🤖 Djon<br>- Марія перевірила лендінг для мобільної версії 📱",
    "🤖 Djon<br>- Андрій має готовий шаблон для соцмереж 🖼️"
];
